'use strict';
import angular from 'angular';

export default class AppShareController {
    /*@ngInject*/
    constructor($stateParams, $http, $state, Application, $scope, Upload) {
        var vm = this;

		//$('.bslider').bootstrapSlider();

        vm.fileUploadTime = Date.now();

        $http.get('/api/applications/' + $stateParams.id).then(
            function(res) {
                var data = res.data;
                Application.load($stateParams.id).then(function() {
                    $scope.$apply(function() {
                        vm.app = Application;
                    }); 
                    
                });
				
            }, function(error) {
                if (error.status == "404") {
                    $state.go('application_main');
                }
                console.log(error);
            });

		
		vm.save = function() {
			Application.save($stateParams.id);
		}
        
        /*vm.next = function() {
            Application.save($stateParams.id);

            if(Application.general.storyboard.quantity && Application.quantity.maxNumber > 1) {
                $state.go('application_screen_quantity', { id: $stateParams.id });
            }
            else {
                $state.go('application_screen_end', { id: $stateParams.id });
            }
        }*/
        
        vm.next = function() {
			Application.next($stateParams.id);
		}

        vm.upload = function (file) {
            Upload.upload({
                url: '/api/applications/'+$stateParams.id+'/upload/share',
                data: {file: file}
            }).then(function (resp) {
                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                vm.fileUploadTime = Date.now();
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };
    }

}


// WEBPACK FOOTER //
// ./client/app/application/share/share.controller.js